<template>
  <div v-loading="loading" class="balance">
    <div>
      <el-input v-model="balance" placeholder="请输入内容" />
    </div>

    <div class="balance_button">
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getBalance, setBalance } from '@/api/admin.js'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      balance: '',
      loading: false
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.id !== oldVal) {
          this.fetchBalance()
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchBalance()
  },
  methods: {
    fetchBalance() {
      getBalance(this.item.id).then(res => {
        this.balance = res.data.quota_number
      })
    },
    async determine() {
      this.loading = true
      await setBalance({ admin_id: this.item.id, quota_number: this.balance })
      this.loading = false
      this.$message({
        message: '设置余额成功',
        type: 'success'
      })
      this.$emit('change')
    }
  }
}
</script>

<style lang="less" scoped>
.balance{
   .balance_button{
     margin-top: 30px;
     display: flex;
     justify-content: end;
   }
}
</style>
